// test988
(988 && 0);
